'use client';

import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const title = css`
  font-size: 18px;
  font-weight: 600;
`;

export const list = css`
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  padding: 1rem 0.5rem;
`;
